import { NewOrderType, TNewOrderForm } from "@/entities/new-order";
import {
  getDatesListFromCountry,
  getKeysFromCountry,
} from "@/entities/new-order/utils";
import BasicButton from "@/UI/BasicButton";
import { Flex } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import { KeywordsAddition, RateAddition, RetentionAddition } from "./addition";
import styles from "./country-item.module.scss";
import CountryReviewsDateList from "./country-reviews-date-list";
import { CountryTableBlock } from "./country-table-block";
import { CountryTotalBlock } from "./country-total-block";

type TCountryTaskBlockProps = {
  countryIndex: number;
  remove: (index: number) => void;
  update: (
    index: number,
    value: TNewOrderForm["countriesList"][number],
  ) => void;
  append: (value: TNewOrderForm["countriesList"][number]) => void;
};

export const CountryTaskBlock = ({
  countryIndex,
  remove,
  update,
  append,
}: TCountryTaskBlockProps) => {
  const { watch, control } = useFormContext<TNewOrderForm>();

  const { type, countriesList } = watch();

  const country = countriesList[countryIndex];

  const taskTypeMap = {
    [NewOrderType.install]: <KeywordsAddition countryIndex={countryIndex} />,
    [NewOrderType.install_with_views]: (
      <KeywordsAddition countryIndex={countryIndex} withViews />
    ),
    [NewOrderType.rate]: <RateAddition countryIndex={countryIndex} />,
    [NewOrderType.install_bp]: <RetentionAddition />,
    [NewOrderType.review]: (
      <CountryReviewsDateList currentIndex={countryIndex} update={update} />
    ),
  };

  return (
    <div className={styles.tasks__container}>
      <Flex gap="lg">
        {type && taskTypeMap[type]}
        <BasicButton
          onClick={() => remove(countryIndex)}
          size="md"
          text="Remove country"
          variant="red"
        />
      </Flex>
      {Boolean(type) &&
        Boolean(getDatesListFromCountry(country).length) &&
        Boolean(getKeysFromCountry(country).length) && (
          <>
            <CountryTableBlock countryIndex={countryIndex} />
            <CountryTotalBlock countryIndex={countryIndex} append={append} />
          </>
        )}
    </div>
  );
};
